import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from 'react-redux';
import { updatePassportDetails } from "../../store/Passport/PassportAction";
import { passportAction } from "../../store/Passport/PassportReducer";

const TravellerVerificationForm = ({
  travellerDetail,
  setChangeFormData,
  sessionId,
  currentTraveller,
  changeFormData
}) => {
  const dispatch = useDispatch();

  const [travellerData, setTravellerData] = useState({
    firstName: travellerDetail.firstName || "",
    lastName: travellerDetail.lastName || "",
    passportNumber: travellerDetail.passportNumber || "",
    nationality: travellerDetail.nationality || "",
    birthDate: travellerDetail.birthDate || "",
    sex: travellerDetail.sex || "",
    occupation: travellerDetail.occupation || "",
    maritalStatus: travellerDetail.maritalStatus || ""
  });

  const { success, error } = useSelector((state) => state.passport);

  useEffect(() => {
  const requiredFields = [
    "firstName",
    "lastName",
    "passportNumber",
    "nationality",
    "birthDate",
    "sex",
    "occupation",
    "maritalStatus"
  ];

  const isComplete = requiredFields.every(
    (field) => travellerDetail[field] && travellerDetail[field].trim().length > 0
  );

  setChangeFormData(!isComplete); // true if incomplete, false if complete
}, [travellerDetail, setChangeFormData]);

  useEffect(() => {
    if (success) {
      setChangeFormData(false);
      toast.success("Traveller information saved successfully!");
      dispatch(passportAction.clearSuccess());
    }

    if (error) {
      toast.error("Failed to save updated details. Please try again...");
      dispatch(passportAction.clearError());
    }
  }, [error, success, dispatch, setChangeFormData]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setTravellerData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
    setChangeFormData(true);
  };

  const isFormComplete = () => {
    const requiredFields = [
      "firstName",
      "lastName",
      "passportNumber",
      "nationality",
      "birthDate",
      "sex",
      "occupation",
      "maritalStatus"
    ];

    return requiredFields.every((field) => {
      return travellerData[field] && travellerData[field].trim().length > 0;
    });
  };

  const handleSubmit = () => {
    if (!isFormComplete()) {
      toast.error("Please fill all required fields before saving.");
      return;
    }

    if (isFormComplete() && !changeFormData) {
      toast.success("Traveller information saved successfully!");
      return;
    }

    if (isFormComplete() && changeFormData) {
      dispatch(updatePassportDetails({ sessionId, currentTraveller, details: travellerData }));
    }
  };

  return (
    <div className="travellerVerificationForm">
      <div className="travellerVerificationForm__heading">
        Traveller {currentTraveller} Information
      </div>
      <form className="travellerVerificationForm__form">
        {/* First Name */}
        <div className="travellerVerificationForm__field">
          <label className="travellerVerificationForm__label" htmlFor="firstName">
            First Name
          </label>
          <input
            type="text"
            name="firstName"
            id="firstName"
            value={travellerData.firstName}
            onChange={handleInputChange}
            className="travellerVerificationForm__input"
            required
          />
        </div>

        {/* Last Name */}
        <div className="travellerVerificationForm__field">
          <label className="travellerVerificationForm__label" htmlFor="lastName">
            Last Name
          </label>
          <input
            type="text"
            name="lastName"
            id="lastName"
            value={travellerData.lastName}
            onChange={handleInputChange}
            className="travellerVerificationForm__input"
            required
          />
        </div>

        {/* Passport Number */}
        <div className="travellerVerificationForm__field">
          <label className="travellerVerificationForm__label" htmlFor="passportNumber">
            Passport Number
          </label>
          <input
            type="text"
            name="passportNumber"
            id="passportNumber"
            value={travellerData.passportNumber}
            onChange={handleInputChange}
            className="travellerVerificationForm__input"
            required
          />
        </div>

        {/* Nationality */}
        <div className="travellerVerificationForm__field">
          <label className="travellerVerificationForm__label" htmlFor="nationality">
            Nationality
          </label>
          <input
            type="text"
            name="nationality"
            id="nationality"
            value={travellerData.nationality}
            onChange={handleInputChange}
            className="travellerVerificationForm__input"
            required
          />
        </div>

        {/* Date of Birth */}
        <div className="travellerVerificationForm__field">
          <label className="travellerVerificationForm__label" htmlFor="birthDate">
            Date of Birth
          </label>
          <input
            type="text"
            name="birthDate"
            id="birthDate"
            value={travellerData.birthDate}
            onChange={handleInputChange}
            className="travellerVerificationForm__input"
            required
          />
        </div>

        {/* Gender */}
        <div className="travellerVerificationForm__field">
          <label className="travellerVerificationForm__label" htmlFor="sex">
            Gender
          </label>
          <input
            type="text"
            name="sex"
            id="sex"
            value={travellerData.sex}
            onChange={handleInputChange}
            className="travellerVerificationForm__input"
            required
          />
        </div>

        {/* Occupation */}
        <div className="travellerVerificationForm__field">
          <label className="travellerVerificationForm__label" htmlFor="occupation">
            Occupation
          </label>
          <input
            type="text"
            name="occupation"
            id="occupation"
            value={travellerData.occupation}
            onChange={handleInputChange}
            className="travellerVerificationForm__input"
            required
          />
        </div>

        {/* Marital Status */}
        <div className="travellerVerificationForm__field">
          <label className="travellerVerificationForm__label" htmlFor="maritalStatus">
            Marital Status
          </label>
          <select
            name="maritalStatus"
            id="maritalStatus"
            value={travellerData.maritalStatus}
            onChange={handleInputChange}
            className="travellerVerificationForm__input"
            required
          >
            <option value="">Select status</option>
            <option value="single">Single</option>
            <option value="married">Married</option>
            <option value="divorced">Divorced</option>
            <option value="widowed">Widowed</option>
          </select>
        </div>
      </form>

      <div className="travellerVerificationForm__submit">
        <button
          type="button"
          onClick={handleSubmit}
          className="travellerVerificationForm__submit-button"
        >
          Save
        </button>
      </div>
    </div>
  );
};

export default TravellerVerificationForm;